package terraultima.web

import kotlinx.browser.document
import org.w3c.dom.HTMLElement

/**
 * Just enough DOM building to keep the screens readable.
 *
 * No framework: the whole app is four screens that repaint wholesale after a replay, so a virtual
 * DOM would be solving a problem this shape does not have. What it would add is a dependency, a
 * build step and 40 KB on a page that people open on mobile data.
 */
class N(val e: HTMLElement) {

    operator fun String.unaryPlus() {
        e.appendChild(document.createTextNode(this))
    }

    fun tag(t: String, cls: String? = null, f: N.() -> Unit = {}): HTMLElement {
        val c = document.createElement(t) as HTMLElement
        if (cls != null) c.className = cls
        N(c).f()
        e.appendChild(c)
        return c
    }

    fun div(cls: String? = null, f: N.() -> Unit = {}) = tag("div", cls, f)
    fun span(cls: String? = null, f: N.() -> Unit = {}) = tag("span", cls, f)
    fun p(cls: String? = null, f: N.() -> Unit = {}) = tag("p", cls, f)
    fun button(cls: String? = null, f: N.() -> Unit = {}) = tag("button", cls, f)
    fun h(cls: String? = null, f: N.() -> Unit = {}) = tag("h2", cls, f)

    /** A line of text, which is most of what this game is. */
    fun line(cls: String? = null, text: String) = div(cls) { +text }

    fun click(h: () -> Unit) {
        e.addEventListener("click", { h() })
    }

    fun attr(name: String, value: String) { e.setAttribute(name, value) }
}

fun paint(host: HTMLElement, f: N.() -> Unit) {
    host.innerHTML = ""
    N(host).f()
}

fun byId(id: String): HTMLElement? = document.getElementById(id) as? HTMLElement
